import { createFileRoute } from "@tanstack/react-router";
import { SectionPage } from "@/components/site/SectionPage";
import { fetchProducts } from "@/lib/products";

export const Route = createFileRoute("/men")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: ["products", "active"],
      queryFn: () => fetchProducts(),
    }),
  head: () => ({
    meta: [
      { title: "Men — KAKAIYS" },
      { name: "description", content: "Hand-finished leather jackets, briefcases, wallets and accessories for men. Lambskin and calfskin, made one piece at a time." },
      { property: "og:title", content: "Men — KAKAIYS" },
      { property: "og:description", content: "Leather jackets, briefcases, wallets and accessories for men." },
      { name: "twitter:image", content: "https://tvmsfjwzfnidomctinqz.supabase.co/storage/v1/object/public/product-images/hover/monsieur-aviator.png" },
      { property: "og:url", content: "https://kakaiys.com/men" },
    ],
      links: [{ rel: "canonical", href: "https://kakaiys.com/men" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Men — KAKAIYS",
          description: "Hand-finished leather jackets, briefcases, wallets and accessories for men.",
          url: "https://kakaiys.com/men",
          isPartOf: { "@id": "https://kakaiys.com/#website" },
          publisher: { "@id": "https://kakaiys.com/#organization" },
        }),
      },
    ],
  }),
  component: () => (
    <SectionPage
      eyebrow="Men"
      title="For Him."
      subtitle="Aviators, café racers, briefcases and bifolds. Built for the long wear."
      filterTag="men"
    />
  ),
});
